<div class="row" *ngIf="(tableItem | json) != '{}'">
    <div class="col-sm-12">
        <div class="row">
            <div class="col">
                <label class="fw-bold">ID</label>
                <input type="text" class="form-control" [(ngModel)]="tableItem.employeeId" [disabled]="true" />
            </div>
        </div>
        <div class="row">
            <div class="col-sm-6">
                <label class="fw-bold">First Name</label>
                <input type="text" class="form-control" [(ngModel)]="tableItem.firstName" required />
            </div>
            <div class="col-sm-6">
                <label class="fw-bold">Last Name</label>
                <input type="text" class="form-control" [(ngModel)]="tableItem.lastName" required />
            </div>
        </div>
        <div class="row">
            <div class="col">
                <label class="fw-bold">Full Name</label>
                <input type="text" class="form-control" [value]="tableItem.firstName + ' ' + tableItem.lastName" [disabled]="true" />
            </div>
        </div>
        <div class="row">
            <div class="col">
                <label class="fw-bold">Title</label>
                <input type="text" class="form-control" [(ngModel)]="tableItem.title" required />
            </div>
        </div>
        <div class="row">
            <div class="col">
                <label class="fw-bold">Win Username</label>
                <input type="text" class="form-control" [(ngModel)]="tableItem.winUserName" required />
            </div>
        </div>
        <div class="row">
            <div class="col">
                <label class="fw-bold">ERP User ID</label>
                <input type="text" class="form-control" [(ngModel)]="tableItem.erpUserId" />
            </div>
        </div>
        <div class="row">
            <div class="col">
                <label class="fw-bold">Web ID</label>
                <input type="text" class="form-control" [(ngModel)]="tableItem.webId" />
            </div>
        </div>
        <div class="row">
            <div class="col">
                <label class="fw-bold">Email</label>
                <input type="text" class="form-control" [(ngModel)]="tableItem.email" required />
            </div>
        </div>
        <div class="row">
            <div class="col-sm-9">
                <label class="fw-bold">Phone</label>
                <input type="text" class="form-control" [(ngModel)]="tableItem.phone" required />
            </div>
            <div class="col-sm-3">
                <label class="fw-bold">Ext</label>
                <input type="text" class="form-control" [(ngModel)]="tableItem.phoneExt" />
            </div>
        </div>
        <div class="row">
            <div class="col">
                <label class="fw-bold">Cell</label>
                <input type="text" class="form-control" [(ngModel)]="tableItem.cell" />
            </div>
        </div>
        <div class="row">
            <div class="col-sm-6">
                <label class="fw-bold">Start</label>
                <kendo-datepicker name="startDate" [(ngModel)]="tableItem.startDate" [format]="'MM/dd/yy'"></kendo-datepicker>
            </div>
            <div class="col-sm-6">
                <label class="fw-bold">End</label>
                <kendo-datepicker name="endDate" [(ngModel)]="tableItem.endDate" [format]="'MM/dd/yy'"></kendo-datepicker>
            </div>
        </div>
        <div class="row">
            <div class="col">
                <label class="fw-bold">Department</label>
                <select name="departmentId" [(ngModel)]="tableItem.departmentId" class="form-select" required>
                    <option *ngFor="let department of departmentList" value="{{department.departmentId}}">{{department.name}}</option>
                </select>
            </div>
        </div>
        <div class="row">
            <div class="col">
                <label class="fw-bold">Manager</label>
                <select name="managerId" [(ngModel)]="tableItem.managerId" class="form-select" required>
                    <option *ngFor="let manager of managerList" value="{{manager.employeeId}}">{{manager.fullName}}</option>
                </select>
            </div>
        </div>
        <div class="row">
            <div class="col-sm-6">
                <label class="fw-bold">Manager?</label>
                <input type="checkbox" id="managerInd" name="managerInd" style="margin:10px;transform: scale(1.5);" [(ngModel)]="tableItem.managerInd" />
            </div>
            <div class="col-sm-6">
                <label class="fw-bold">Active?</label>
                <input type="checkbox" id="activeInd" name="activeInd" style="margin:10px;transform: scale(1.5);" [(ngModel)]="tableItem.activeInd" />
            </div>
        </div>
        <div class="row">
            <div class="col m-2 text-end">
                <button class="btn btn-primary m-2" (click)="save()">Save</button>
                <button class="btn btn-secondary m-2" (click)="cancel()">Cancel</button>
            </div>
        </div>
    </div>
</div>
